const siteOrigin = "https://nwmvietnam.com.vn";

function setMetaContent(selector, content) {
  const element = document.querySelector(selector);
  if (element) {
    element.setAttribute("content", content);
  }
}

export function setPageSeo(page) {
  document.title = page.title;
  setMetaContent('meta[name="description"]', page.description);
  setMetaContent('meta[property="og:title"]', page.title);
  setMetaContent('meta[property="og:description"]', page.description);

  const canonicalUrl = new URL(page.path, siteOrigin).toString();
  const canonicalLink = document.querySelector('link[rel="canonical"]');
  if (canonicalLink) {
    canonicalLink.setAttribute("href", canonicalUrl);
  }
  setMetaContent('meta[property="og:url"]', canonicalUrl);
}
